import {Component, ElementRef, OnInit, Renderer2, ViewChild} from '@angular/core';
import {SidebarService} from "@components/my-web-desk/sidebar/sidebar.service";
import {BehaviorSubject, fromEvent} from "rxjs";
import {CdkDragDrop, moveItemInArray, transferArrayItem} from "@angular/cdk/drag-drop";
import {ToastrService} from "ngx-toastr";
import {Task} from "@app/interfaces/task";
import {BacklogService} from "@components/backlog/backlog.service";
import {MatDialog} from "@angular/material/dialog";
import {NewTaskModalComponent} from "@components/my-web-desk/new-task-modal/new-task-modal.component";
import {ConstantsService} from "@app/services/constants/constants.service";
import {BackendResponse} from "@app/interfaces/backendResponse";
import {HelperService} from "@app/services/helper/helper.service";
import {AddSprintModalComponent} from "@components/sprint/add-sprint-modal/add-sprint-modal/add-sprint-modal.component";
import {DialogConfirmComponent} from "@common-components/dialogues/dialog-confirm/dialog-confirm.component";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {SprintService} from "@components/sprint/sprint.service";
import {ProjectsService} from "@components/projects/projects.service";
import {Projects} from "@app/interfaces/projects";

export interface Sprint {
    id: string;
    tasks: [];
    button: true;
    deletePermission: boolean;
}

export interface BackLogTask {
    _id: '';
    comments: [];
}


@Component({
    selector: 'app-backlog',
    templateUrl: './backlog.component.html',
    styleUrls: ['./backlog.component.css']
})


export class BacklogComponent implements OnInit {
    sidebarState: boolean;
    @ViewChild('backlogList') bckList: ElementRef;

    sprints = [];
    backlog = {id: '', tasks: []};
    task: BackLogTask[] = [];

    loader = false;
    taskPreview = false;

    loggedInUser = [];
    flag = false;


    openedTaskId = '';
    openedTaskSort = '';
    project_id: string = '';
    project: Projects = null;


    @ViewChild('menu') menuTrigger;
    storyPoint_2 = 0;
    buttons = [1, 3, 5, 8, 13];
    isAdmin: boolean;


    constructor(private sidebarService: SidebarService,
                private renderer: Renderer2,
                private toastr: ToastrService,
                private backlogService: BacklogService,
                private matDialog: MatDialog,
                private constants: ConstantsService,
                private helperService: HelperService,
                private route: ActivatedRoute,
                private sprintService: SprintService,
                private projectsService: ProjectsService,
                private router: Router) {

        fromEvent(window, 'resize').subscribe(event => {
            let element = document.getElementById('backlogList');
            if (element !== undefined) {
                this.renderer.removeClass(element, 'vh-100');
            }
        });
    }


    async ngOnInit() {
        this.isAdmin = this.constants.getAdminStatus();
        this.route.params.subscribe((params: Params) => {
            if (params.projectId) {
                this.project_id = params.projectId;
            } else {
                const activeProject: Projects = this.projectsService.userActiveProject.getValue();
                if (activeProject) {
                    this.project_id = activeProject._id;
                }
            }
        });

        this.project = this.projectsService.userActiveProject.getValue();
        if (this.project_id == '') {
            let activeProject: Projects = this.projectsService.userActiveProject.getValue();
            if (activeProject) {
                this.project_id = activeProject._id;
            }
        }

        setTimeout(async () => {
            this.loggedInUser = this.constants.getUserData();
            this.loader = true;
            this.getBacklogData();
            this.getActiveSprints();
            this.loader = false;
        }, 200);

    }

    onTrackDrop(event: CdkDragDrop<Sprint[]>) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    }


    setStoryPoint(task) {
        if (task) {
            this.backlogService.setStoryPoints(task['_id'], this.storyPoint_2, task['sort']).subscribe((response: BackendResponse) => {
                task['story_points'] = this.storyPoint_2;
            });
        }
    }


    get trackIds() {
        const array = this.sprints.concat(this.backlog);
        return array.map(track => track.id);
    }

    onTalkDrop(event: CdkDragDrop<Sprint[]>) {

        if (event.previousContainer.id === 'backlog') {
            let sprintId = event.container.id;

            let sprint = this.sprints.find(x => x.id === sprintId);
            if (sprint.status === 'closed') {
                this.toastr.info('Sprint je zatvoren. Nije moguće dodati zadatke u sprint.');
                return;
            }
        }


        if (event.container.id === event.previousContainer.id) {
            this.toastr.info('Zadatak možete prebaciti samo u kolonu različitu od trenutne.');
            return;
        }


        transferArrayItem(event.previousContainer.data,
            event.container.data,
            event.previousIndex,
            event.currentIndex);

        const location = event.container.id;
        const movedTaskId = event.container.data[event.currentIndex]['_id'];
        this.moveTask(movedTaskId, location);


    }

    getBacklogData() {
        return new Promise(async (resolve, reject) => {
            try {
                if (this.project_id === '') {
                    const activeProject: Projects = this.projectsService.userActiveProject.getValue();
                    if (activeProject) {
                        this.project_id = activeProject._id;
                    }

                }
                if (this.project_id === '') {
                    this.toastr.info('Molimo Vas izaberite projekat za pregled backlog-a.');
                    await this.router.navigate(['/projects']);
                    return;
                } else {
                    this.backlogService.getData(this.project_id).subscribe((response: BackendResponse) => {
                        if (response.type == 'success') {
                            this.backlog.tasks = response.data;
                            this.backlog.id = 'backlog';

                            this.backlog.tasks.forEach(item => {
                                let assignedArray = [];
                                let assignedIds: any[] = item['assigned'];
                                assignedIds.forEach(x => {
                                    assignedArray.push(this.helperService.getDataForUserId(x));
                                });
                                item['assigned'] = assignedArray;
                                item['statusName'] = this.helperService.tranformStatusToName(item.status);

                            });
                            resolve();
                        } else {
                            this.toastr.error('Došlo je do greške. Molimo Vas obratite se korisničkoj podršci.');
                            reject();
                        }
                    });
                }


            } catch (e) {
                reject(e);
            }
        });


    }

    getActiveSprints() {
        return new Promise((resolve, reject) => {
            try {
                this.backlogService.getActiveSprints(this.project_id).subscribe(response => {
                    let sprints: any[] = response.data;
                    this.sprints = sprints.map(item => {

                        //assigned avatars
                        let tasks: any[] = item.tasks;
                        let assignedData: any = [];
                        tasks.map((x: Task) => {
                            x['statusName'] = this.helperService.tranformStatusToName(x.status);
                            assignedData = [];
                            let assignedArray = x.assigned;
                            assignedArray.forEach(x => {
                                assignedData.push(this.helperService.getDataForUserId(x))
                            });
                            x.assigned = assignedData;
                            return x;
                        });

                        const data = {
                            id: item._id,
                            tasks: tasks,
                            name: item.name,
                            deletePermission: false,
                            status: item.status
                        };
                        return data;
                    });
                });
            } catch (e) {
                reject(e);
            }
        });
    }


    addNewTaskToBacklog() {
        const project = this.projectsService.userActiveProject.getValue();
        this.matDialog.open(NewTaskModalComponent, {
            disableClose: true,
            height: '600px',
            width: '800px',
            data: {
                id: 'modal-component',
                mode: 'new',
                sort: 'task',
                backlog: true,
                project: project

            }
        }).afterClosed().subscribe(async (response) => {
            if (response === true) {
                await this.getBacklogData();
            }
        });

    }

    taskPreviewHandler(id, sort) {
        this.openedTaskId = id;
        this.openedTaskSort = sort;
        this.taskPreview = true;

    }

    closeTaskPreviewHandler(event) {
        if (event === true) {
            this.taskPreview = false;
        }
    }


    createNewSprint() {
        this.backlogService.createNewSprint(this.project_id).subscribe(async (responseData: BackendResponse) => {
            this.backlogService.sprintCreated.next(true);
            if (responseData.type === 'error') {
                this.toastr.error('Došlo je do greške prilikom dodavanja sprinta. Molimo vas obratite se korisničkoj podršci. ');
            }
            await this.getActiveSprints();
        });
    }


    addNewTaskToSprint(sprintId) {
        const dialog = this.matDialog.open(NewTaskModalComponent, {
            disableClose: true,
            height: '600px',
            width: '800px',
            data: {
                id: 'modal-component',
                mode: 'new',
                sprintId: sprintId,
                project: this.project,
                sort: 'task',
            }
        });
        dialog.afterClosed().subscribe(async (result) => {
            if (result) {
                await this.getActiveSprints();
            }
        });
    }

    moveTask(taskId, location) {
        this.backlogService.moveTask(taskId, location).subscribe((response: BackendResponse) => {
            if (response.type === 'success') {
                this.getBacklogData();
                this.getActiveSprints();
            } else {
                this.toastr.error('Došlo je do greške. Molimo Vas obratite se korisničkoj podršci.');
                throw new Error('moveTask');

            }
        });

    }


    activateSprint(index) {
        let sprint = this.sprints[index];
        if (sprint.tasks.length === 0) {
            this.toastr.info('Sprint je prazan. Molimo Vas dodajte zadatke.');
            return;
        } else {

            this.backlogService.activateSprint(sprint.id).subscribe(async (responseData: BackendResponse) => {
                if (responseData.type === 'success') {
                    this.toastr.success('Uspješno ste pokrenuli sprint.');
                    await this.getActiveSprints();
                } else {
                    this.toastr.success('Došlo je do greške prilikom pokretanja sprinta.');
                }
            });
        }


    }

    //za edit sprinta
    openSprintModal(sprintId) {
        this.matDialog.open(AddSprintModalComponent, {
            height: '55%',
            // disableClose: true,
            width: '25%',
            data: {
                id: sprintId,
                mode: 'edit'
            }
        }).afterClosed().subscribe(async (response) => {
            if (response === true) {
                this.backlogService.sprintCreated.next(true);
                await this.getActiveSprints();

            }
        });
    }


    deleteSprint(sprintId) {
        this.matDialog.open(DialogConfirmComponent, {
            width: '15%',
            height: '19%',
            disableClose: true,
            data: {
                message: 'Da li želite da izbrišete sprint?'
            }
        }).afterClosed().subscribe(response => {
            if (response == true) {
                this.sprintService.deleteSprint(sprintId).subscribe(async (responseData: BackendResponse) => {
                    if (responseData.type === 'success') {
                        await this.getBacklogData();
                        await this.getActiveSprints();
                    }
                });
            }
        });
    }

    // za input polje
    setStoryPointSprintTask(event, location, taskIndex) {
        if (event.key) {
            if (event.key === 'Enter') {

                if (location !== 'backlog') {
                    let sprint = this.sprints.filter(item => item.id === location);
                    let task: any[] = sprint[0]['tasks'][taskIndex];
                    if (task) {
                        task['visibility'] = null;
                        task['story_points'] = this.storyPoint_2;
                        this.backlogService.setStoryPoints(task['_id'], this.storyPoint_2, 'task')
                            .subscribe((responseData: BackendResponse) => {
                                if (responseData.type === 'success') {
                                    task['story_points'] = this.storyPoint_2;
                                } else {
                                    this.toastr.error('Došlo je do greške. Molimo Vas obratite se korisničkpj podršci.');
                                }
                            });
                    }
                } else {
                    let task: any[] = this.backlog['tasks'][taskIndex];
                    if (task) {
                        task['visibility'] = null;
                        task['story_points'] = this.storyPoint_2;
                        this.backlogService.setStoryPoints(task['_id'], this.storyPoint_2, 'task')
                            .subscribe((responseData: BackendResponse) => {
                                if (responseData.type === 'success') {
                                    task['story_points'] = this.storyPoint_2;
                                } else {
                                    this.toastr.error('Došlo je do greške. Molimo Vas obratite se korisničkpj podršci.');
                                }
                            });
                    }
                }

            }
        }
    }

    async onSprintChanged(event) {
        await this.getBacklogData();
        await this.getActiveSprints();

    }
}
